import { Box, Button, HStack, IconButton, Tooltip, useToast } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { MdOutlineFileDownload, MdOutlinePrint } from 'react-icons/md';
import RefundReceipt from './RefundReceipt';
import { RefundReceiptData, refundReceiptFilename } from './refundReceiptData';
import { useReceiptCapture } from './useReceiptCapture';

/** Baixar (PNG) e imprimir o comprovante de um estorno. */
const RefundReceiptActions: FC<{
  data: RefundReceiptData;
  size?: 'xs' | 'sm';
}> = ({ data, size = 'sm' }) => {
  const toast = useToast();
  const [downloading, setDownloading] = useState(false);
  const { ref, download, print } = useReceiptCapture(refundReceiptFilename(data), (description) =>
    toast({
      title: 'Erro',
      description,
      status: 'error',
      duration: 3000,
      isClosable: true,
    }),
  );

  const handleDownload = async () => {
    setDownloading(true);
    await download();
    setDownloading(false);
  };

  return (
    <>
      {/* Fora da tela, mas no DOM: a captura e a impressão leem o nó já desenhado. */}
      <Box position="fixed" left="-10000px" top={0} pointerEvents="none" aria-hidden>
        <RefundReceipt data={data} ref={ref} />
      </Box>
      <HStack spacing={2}>
        <Button
          size={size}
          colorScheme="brand"
          variant="outline"
          leftIcon={<MdOutlineFileDownload />}
          isLoading={downloading}
          onClick={handleDownload}
        >
          Comprovante
        </Button>
        <Tooltip label="Imprimir comprovante">
          <IconButton
            aria-label="Imprimir comprovante"
            size={size}
            colorScheme="brand"
            variant="outline"
            icon={<MdOutlinePrint />}
            onClick={print}
          />
        </Tooltip>
      </HStack>
    </>
  );
};

export default RefundReceiptActions;
